export default {
  zh: {
    rule_details: '奖励天数= 邀请奖励天数基础值/套餐台数。比如说，您是1台设备套餐，邀请好友购买了1台设备的月套餐，则您和好友都可获得5天的奖励天数（5/1=5）。如果您是2台设备套餐，邀请好友购买了1台设备年付套餐，则您可以获得15天的奖励天数（30/2=15），好友可以获得30天的奖励天数（30/1=30）。邀请奖励天数基础值阶梯表如下：',
    table_head: '邀请奖励天数基础值阶梯表（单位：天）',
    device_number: '设备数（台）',
    month_package: '月度套餐',
    quarter_package: '季度套餐',
    year_package: '年付套餐'
  },
  en: {
    rule_details: 'Reward time = Tier reward time standard/ Device number. For example, if you have bought 1 device plan, and successfully referred your friend to buy 1 device monthly plan, both of you will get 5-day reward time (5/1=5); If your device number is 2, and you have successfully referred your friend to buy 1 device yearly plan, you’ll get 15-day reward time(30/2=15) and your friend will get 30-day reward time( 30/1=30). The ladder table of tier reward time standard is as follows:',
    table_head: 'Tier Rewards Time Standard (Unit: Day)',
    device_number: 'Device Number',
    month_package: '1 Month',
    quarter_package: '3 Months',
    year_package: 'Yearly Plan'
  }
}



// WEBPACK FOOTER //
// ./src/views/app/rewardRules/lang.js